import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import FinnAppDashboard from './App';
import { queryClient } from './shared/services/queryClient';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <FinnAppDashboard />
    </QueryClientProvider>
  </React.StrictMode>
);
